export default __webpack_public_path__ + "img/6f6b45d929a576bdfd635cbac3a7d51b.gif";